import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

/**
 * MetaPixelTracker - A component that conditionally renders Meta Pixel tracking script
 * based on the current route. Only renders on public-facing pages, excluding admin routes.
 */
const MetaPixelTracker = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  // List of admin/private routes where pixel should NOT be included
  const adminRoutes = [
    '/admin',
    '/login',
    '/dashboard',
    '/n9',
    '/confirmProperty',
    '/ServiceRequest'
  ];
  
  // Check if current path is in admin routes
  // Also check if path contains any admin route as a prefix
  const isAdminRoute = adminRoutes.some(route => 
    currentPath === route || 
    currentPath.startsWith(`${route}/`)
  );

  // Only render Meta Pixel script if NOT on admin route
  if (isAdminRoute) {
    return null;
  }

  return (
    <Helmet>
      {/* Meta Pixel Code */}
      <script>
      {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '580842125097232');
        fbq('track', 'PageView');
      `}
      </script>
      <noscript>
        {`<img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=580842125097232&ev=PageView&noscript=1"
        />`}
      </noscript>
    </Helmet>
  );
};

export default MetaPixelTracker;
